var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C9.35814 20 8.75349 19.6753 8.32558 19.1095L6.93023 17.2542C6.90233 17.2171 6.7907 17.1707 6.74419 17.1614H6.27907C2.4 17.1614 0 16.1132 0 10.8998V6.2616C0 2.16141 2.16744 0 6.27907 0H13.7209C17.8326 0 20 2.16141 20 6.2616V10.8998C20 15 17.8326 17.1614 13.7209 17.1614H13.2558C13.1814 17.1614 13.1163 17.1985 13.0698 17.2542L11.6744 19.1095C11.2465 19.6753 10.6419 20 10 20ZM6.27907 1.39147C2.94884 1.39147 1.39535 2.94063 1.39535 6.2616V10.8998C1.39535 15.0928 2.83721 15.7699 6.27907 15.7699H6.74419C7.21861 15.7699 7.75814 16.039 8.04651 16.4193L9.44186 18.2746C9.76744 18.7013 10.2326 18.7013 10.5581 18.2746L11.9535 16.4193C12.2605 16.0111 12.7442 15.7699 13.2558 15.7699H13.7209C17.0512 15.7699 18.6047 14.2208 18.6047 10.8998V6.2616C18.6047 2.94063 17.0512 1.39147 13.7209 1.39147H6.27907Z",
    fill: "#6BA6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.97223C9.47913 9.97223 9.06982 9.55479 9.06982 9.04459C9.06982 8.53438 9.48843 8.11694 10.0001 8.11694C10.5117 8.11694 10.9303 8.53438 10.9303 9.04459C10.9303 9.55479 10.521 9.97223 10.0001 9.97223Z",
    fill: "#6BA6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7208 9.97223C13.1998 9.97223 12.7905 9.55479 12.7905 9.04459C12.7905 8.53438 13.2091 8.11694 13.7208 8.11694C14.2324 8.11694 14.651 8.53438 14.651 9.04459C14.651 9.55479 14.2417 9.97223 13.7208 9.97223Z",
    fill: "#6BA6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27935 9.97223C5.75842 9.97223 5.34912 9.55479 5.34912 9.04459C5.34912 8.53438 5.76773 8.11694 6.27935 8.11694C6.79098 8.11694 7.20959 8.53438 7.20959 9.04459C7.20959 9.55479 6.80028 9.97223 6.27935 9.97223Z",
    fill: "#6BA6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.11c696ca5f35875bbd3e720f12187f97.svg";
export { ForwardRef as ReactComponent };